import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import {logOperationalMetric} from "../../util/CommonUtils";
import {EWASTE_API_PATHS, HTTP_METHOD, PROCESS_NAME} from "../constants/EWasteApiPaths";

const metricProcessName = "SCC_EWASTE_ITEM_CREATE";
const SUB_PROCESS = "createEWasteItem";

/**
 * Calls OculusService.CreateEWasteItem via Boson FlowApiGateway.
 *
 * @param {string} containerId       Parent container UUID.
 * @param {string} itemName          Display name (e.g. "MacBook Pro 13").
 * @param {string} wasteProfileId    Waste code (e.g. "20 01 36").
 * @param {number} quantity          Item count (>= 1).
 * @param {{weight: number, unit: string}} totalWeight  EWasteWeight struct.
 * @param {string} locale            WADM locale (e.g. "en_GB").
 *
 * Note: 3P has no Hummingbird interaction (Hummingbird maps wasteProfileId →
 * ewcCode for 1P), so we send ewcCode = wasteProfileId directly.
 * @returns {Promise<{success: boolean, itemId?: string, status?: string}>}
 */
export async function createEWasteItem(containerId, itemName, wasteProfileId, quantity, totalWeight, locale) {
    const startTime = Date.now();
    const requestBody = {
        containerId,
        itemName,
        wasteProfileId,
        // 3P: no Hummingbird mapping, so ewcCode is the wasteProfileId as-is.
        ewcCode: wasteProfileId,
        quantity,
        totalWeight,
        locale
    };

    const request = {
        resourcePath: EWASTE_API_PATHS.CREATE_ITEM,
        httpMethod: HTTP_METHOD.POST,
        processName: PROCESS_NAME.OCULUS,
        requestBody
    };

    try {
        const response = await getAPIGatewayDataFromParent(request);
        if (response.status === 200) {
            logOperationalMetric(startTime, metricProcessName, SUB_PROCESS, true);
            return {
                success: true,
                itemId: response.data && response.data.itemId,
                status: response.data && response.data.status
            };
        }
        logOperationalMetric(startTime, metricProcessName, SUB_PROCESS, false);
        return {success: false};
    } catch (error) {
        logOperationalMetric(startTime, metricProcessName, SUB_PROCESS, false);
        return {success: false};
    }
}



// WEBPACK FOOTER //
// ./src/commons/api/CreateEWasteItem.js